import { cn } from "cn"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-pulse rounded-md bg-neutrals-300 dark:bg-neutrals-800",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
